import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6feaff65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-table box" }
const _hoisted_2 = { class: "view-table__header" }
const _hoisted_3 = { class: "view-table__description" }
const _hoisted_4 = { class: "view-table__pagination" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Страница", -1))
const _hoisted_6 = ["max"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "из", -1))
const _hoisted_8 = {
  key: 0,
  class: "table is-bordered"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "th-number" }, "№"),
    /*#__PURE__*/_createElementVNode("th", null, "Сумма"),
    /*#__PURE__*/_createElementVNode("th", null, "Инфо"),
    /*#__PURE__*/_createElementVNode("th", null, "Дата создания"),
    /*#__PURE__*/_createElementVNode("th", null, "Статус"),
    /*#__PURE__*/_createElementVNode("th", null, "Действия")
  ])
], -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-external-link-alt" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "table-container__empty"
}
const _hoisted_17 = {
  key: 0,
  class: "view-table_options"
}
const _hoisted_18 = { class: "view-table_options__content box is-radiusless" }
const _hoisted_19 = { class: "field mt-auto" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Показывать по", -1))
const _hoisted_21 = { class: "control" }
const _hoisted_22 = { class: "select" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сортировка", -1))
const _hoisted_26 = { class: "control" }
const _hoisted_27 = { class: "select" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "view-table_options__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddBalanceForm = _resolveComponent("AddBalanceForm")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_EditBalanceForm = _resolveComponent("EditBalanceForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Всего найдено " + _toDisplayString(_ctx.ctx.meta.total), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "number",
          min: "1",
          max: _ctx.ctx.meta.page.total,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args)))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.page]
        ]),
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.ctx.meta.page.total), 1)
      ]),
      _createElementVNode("button", {
        class: "button is-info",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOptions = true))
      }, "Опции"),
      (_ctx.ctx.balanceParams?.allow_accual_create)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button is-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
          }, "Добавить начисление"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-container with-scrollbar", {'busy':_ctx.ctx.isLoading, 'lock': _ctx.showOptions}])
    }, [
      (_ctx.ctx.list.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (history) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: history.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(history.id), 1),
                  _createElementVNode("td", null, _toDisplayString(history.amount), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", null, _toDisplayString(history.info), 1),
                    (history.crm_link)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: history.crm_link,
                          title: "Посмотреть клиента в amocrm"
                        }, _hoisted_12, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.dateTimeFromDateString(history.created_at)), 1),
                  _createElementVNode("td", null, _toDisplayString(history.status_name), 1),
                  _createElementVNode("td", null, [
                    (history.amount > 0 && _ctx.earningPendingStatuses.includes(history.status_id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (history.status_id === 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["button is-danger", { 'is-loading': _ctx.loadingStates[history.id] }]),
                                onClick: ($event: any) => (_ctx.declineEarning(history.id))
                              }, "Отказать", 10, _hoisted_13))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: _normalizeClass(["button is-success", { 'is-loading': _ctx.loadingStates[history.id] }]),
                                onClick: ($event: any) => (_ctx.acceptEarning(history.id))
                              }, "Разрешить", 10, _hoisted_14))
                        ], 64))
                      : _createCommentVNode("", true),
                    (history.amount > 0 && !_ctx.earningPendingStatuses.includes(history.status_id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.ctx.balanceParams?.allow_accual_create)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["button is-success", { 'is-loading': _ctx.loadingStates[history.id] }]),
                                onClick: ($event: any) => (_ctx.openEditModal(history))
                              }, "Изменить", 10, _hoisted_15))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_16, "Пусто"))
    ], 2),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "view-table_options__overlay",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("p", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.limit) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.LimitPageVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant.value,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_23))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.limit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("p", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sorting) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.sortingVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_28))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sorting]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "button is-primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, "Применить"),
              _createElementVNode("button", {
                class: "button is-ghost",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Сбросить"),
              _createElementVNode("button", {
                class: "button is-light",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Отмена")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseModal, {
      "is-visible": _ctx.isAddModalOpen,
      title: "Добавить начисление",
      onClose: _ctx.closeAddModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddBalanceForm, {
          ref: (el) => { _ctx.formRef = el },
          onSuccess: _ctx.onAddBalance,
          agentId: _ctx.agentId,
          mlmId: _ctx.mlmId
        }, null, 8, ["onSuccess", "agentId", "mlmId"])
      ]),
      _: 1
    }, 8, ["is-visible", "onClose"]),
    _createVNode(_component_BaseModal, {
      "is-visible": _ctx.isEditModalOpen,
      title: "Изменить начисление",
      onClose: _ctx.closeEditModal
    }, {
      default: _withCtx(() => [
        (_ctx.selectedRecord)
          ? (_openBlock(), _createBlock(_component_EditBalanceForm, {
              key: 0,
              ref: (el) => { _ctx.formRef = el },
              onSuccess: _ctx.onEditBalance,
              historyId: _ctx.selectedRecord.id,
              amount: _ctx.selectedRecord.amount
            }, null, 8, ["onSuccess", "historyId", "amount"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-visible", "onClose"])
  ]))
}